// import React, { useRef, useEffect, useState } from "react";
import MapSight from "./mapsight/MapSight.tsx"

import "./Map.css"

class Map extends MapSight {}

export default Map
